/**
 * @todo: This is dead code, it should be removed due to next release.
 */

export default class TimeService {
  static readonly epgOffsetMaxAge = 1000 * 60 * 60 * 24; // 1 day in milliseconds
  #epgOffset: number | undefined;
  readonly #fetchEpgOffset: () => Promise<number>;

  constructor(fetchEPGTime: () => Promise<{timestamp: number}>) {
    /* this constructor just for clean previously stored value in session storage */
    try {
      sessionStorage.removeItem('epgOffset');
      sessionStorage.removeItem(maxAgeName('epgOffset'));
    } catch {}

    return;

    this.#epgOffset = getPreservedNumber('epgOffset');

    /* it should call API only once, and only in case we have not preserved value */
    this.#fetchEpgOffset = async () => {
      if (this.#epgOffset !== undefined) {
        return Promise.resolve(this.#epgOffset);
      }
      return fetchEPGTime()
        .then((epgTime: {timestamp: number}) => {
          const offset = Math.floor(Date.now() / 1_000) - epgTime.timestamp;
          preserveValue('epgOffset', offset.toString(), Date.now() + TimeService.epgOffsetMaxAge);
          return offset;
        })
        .catch(() => {
          return 0;
        });
    };
  }

  async getEPGOffset() {
    if (this.#epgOffset === undefined) {
      this.#epgOffset = await this.#fetchEpgOffset();
    }
    return Promise.resolve(this.#epgOffset);
  }

  async getEPGTime() {
    return (await this.getEPGOffset()) + Math.floor(Date.now() / 1_000);
  }
}

function getPreservedNumber(key: string) {
  const preserved = getPreservedValue(key);
  const value = parseFloat(preserved ?? '');
  if (Number.isFinite(value)) {
    return value;
  }
}

function getPreservedValue(key: string) {
  let value;
  try {
    value = sessionStorage.getItem(key);
  } catch {}

  try {
    const maxAge = sessionStorage.getItem(maxAgeName(key));
    const timestamp = maxAge === null ? Infinity : parseInt(maxAge, 10);
    if (Date.now() >= timestamp) {
      value = null;
      sessionStorage.removeItem(key);
      sessionStorage.removeItem(maxAgeName(key));
    }
  } catch {}

  return value;
}

function preserveValue(key: string, value: string, maxAge?: number) {
  try {
    sessionStorage.setItem(key, value);
    if (maxAge !== undefined) {
      sessionStorage.setItem(maxAgeName(key), maxAge.toString());
    }
  } catch {}
}

function maxAgeName(key: string) {
  return `${key}-max-age`;
}
